import { useNavigate } from 'react-router-dom'
import { Button, Card } from 'react-bootstrap'
import CustomCard from '#Components/Card'
const { Header, Body, Footer, Title, Text } = Card;

export function BlogError2({ removeError, titleText, mainText }) {
    // Note, this screen required a fuller Card component because couldn't render Boundary inside ScrollingCard without making extra clones
    const navigate = useNavigate()
    const header = {
        // icon: 'angry',
        // headText: 'Something Broke',
        HeadElement: () => <h2 className="px-3 m-0 mt-1 align-self-center text-warning" style={{ zIndex: 2 }}><i className={`fa fa-angry`}></i> <span className="d-inline-block ms-3">Something broke</span></h2>,
        w0: 39,
        h0: 50,
        size: 90
    }
    return (
        <CustomCard header={header} style={{ minHeight: '87vh' }} id='blogError2'>
            <div className="w-100 d-flex flex-column align-items-center">
                <Title>{titleText}</Title>
                <Text className="text-center my-5">{mainText}</Text>
                <Button variant="outline-warning" className="px-5" onClick={() => { removeError(); navigate('/blog') }}>
                    <i className="fa fa-blog me-3"></i>
                Return to Blog Intro
                </Button>
            </div>
        </CustomCard>
    )
}

export function BlogError1({ removeError, titleText, mainText }) {
    const navigate = useNavigate()
    return (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center" >
            <Card className="BlogErrorCard position-relative" style={{top: '-50px'}}>
                <Header className="bg-warning">
                    <div className="d-flex">
                        <i className="fa fa-angry fs-1 d-inline-block" style={{flexGrow: 0, marginRight: '30px'}}></i>
                        <h4 className="m-0" style={{alignSelf: 'center'}}>Something Broke</h4>
                    </div>
                </Header>
                <Body style={{color: 'var(--dark)'}}>
                    <Title>
                        {titleText}
                    </Title>
                    <Text className="text-center">
                        {mainText}
                    </Text>
                </Body>
                <Footer className="d-flex justify-content-end">
                    <Button variant="outline-warning" className="px-5" onClick={() => { removeError(); navigate('/blog') }}>
                        <i className="fa fa-home me-3"></i>
                        Return to Blog Intro
                    </Button>
                </Footer>
            </Card>
        </ div>
    )
}